var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('Pane',{attrs:{"title":"员工瓴云账号信息填写表","showRemarks":false}},[[_vm._v("重新发起员工瓴云账号信息填写表流程")]],2),_c('div',{staticStyle:{"padding":"0 10px"}},[_c('BranchEmployeeForm',{ref:"form",attrs:{"editData":_vm.extra},on:{"submit":_vm.handleSubmit,"close":_vm.handleClose}})],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }